import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { BoxIcon, GavelIcon, SearchIcon, FilterIcon, ClockIcon, CalendarIcon, DollarSignIcon, TrendingUpIcon, TruckIcon, TagIcon, PlusIcon, UsersIcon, BarChart2Icon, ArrowRightIcon, CheckCircleIcon, TimerIcon, ShieldIcon, UserPlusIcon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Progress } from '@/components/ui/progress';
const WholesaleAuctions = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('active');
  const auctions = [{
    id: 'AUC-2023-1245',
    title: 'Bulk iPhone 12 & 13 Models',
    devices: 25,
    startingBid: '$8,750',
    currentBid: '$10,250',
    bids: 8,
    status: 'Active',
    timeLeft: '12h 32m',
    endDate: '2023-07-21',
    seller: 'TechTrade Solutions',
    syndicateBuying: true,
    syndicateInfo: {
      name: 'Premium iPhone Collective',
      members: 5,
      capitalRaised: '$90,000',
      targetCapital: '$100,000',
      progress: 90
    }
  }, {
    id: 'AUC-2023-1244',
    title: 'Samsung Galaxy S22 Collection',
    devices: 18,
    startingBid: '$5,400',
    currentBid: '$6,120',
    bids: 5,
    status: 'Active',
    timeLeft: '1d 8h',
    endDate: '2023-07-22',
    seller: 'Mobile Source LLC',
    syndicateBuying: false
  }, {
    id: 'AUC-2023-1243',
    title: 'Google Pixel 6 Pro Lot',
    devices: 12,
    startingBid: '$3,600',
    currentBid: '$3,950',
    bids: 3,
    status: 'Active',
    timeLeft: '2d 4h',
    endDate: '2023-07-23',
    seller: 'Wireless Wholesale Co',
    syndicateBuying: true,
    syndicateInfo: {
      name: 'Pixel Traders Group',
      members: 3,
      capitalRaised: '$4,000',
      targetCapital: '$5,000',
      progress: 80
    }
  }, {
    id: 'AUC-2023-1242',
    title: 'Mixed Apple Devices (Refurbished)',
    devices: 30,
    startingBid: '$9,000',
    currentBid: '$10,500',
    bids: 12,
    status: 'Ended',
    timeLeft: 'Ended',
    endDate: '2023-07-19',
    seller: 'TechTrade Solutions',
    syndicateBuying: false
  }];
  const auctionStats = {
    activeAuctions: 12,
    upcomingAuctions: 5,
    completedThisMonth: 24,
    totalBids: 156,
    averagePriceIncrease: '18.4%'
  };
  const recentBids = [{
    id: 1,
    auction: 'AUC-2023-1245',
    bidder: 'Mobile Resellers Inc',
    amount: '$10,250',
    time: '1 hour ago'
  }, {
    id: 2,
    auction: 'AUC-2023-1245',
    bidder: 'Phone Wholesale Inc',
    amount: '$10,100',
    time: '2 hours ago'
  }, {
    id: 3,
    auction: 'AUC-2023-1245',
    bidder: 'Global Phone Exchange',
    amount: '$9,800',
    time: '3 hours ago'
  }, {
    id: 4,
    auction: 'AUC-2023-1244',
    bidder: 'Mobile Resellers Inc',
    amount: '$6,120',
    time: '5 hours ago'
  }];
  return <div className="space-y-6" data-id="element-4022">
      <div className="flex items-center justify-between" data-id="element-4023">
        <div data-id="element-4024">
          <h1 className="text-2xl font-bold" data-id="element-4025">Wholesale Auctions</h1>
          <p className="text-sm text-muted-foreground" data-id="element-4026">
            Buy and sell devices in bulk through competitive auctions
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-4027">
          <Button variant="outline" onClick={() => navigate('/syndicate-hub')} data-id="element-4028">
            <UsersIcon className="mr-2 h-4 w-4" data-id="element-4029" />
            Syndicate Hub
          </Button>
          <Button variant="outline" data-id="element-4030">
            <FilterIcon className="mr-2 h-4 w-4" data-id="element-4031" />
            Filter
          </Button>
          <Button data-id="element-4032">
            <PlusIcon className="mr-2 h-4 w-4" data-id="element-4033" />
            Create Auction
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-4034">
        <Card data-id="element-4035">
          <CardContent className="p-4" data-id="element-4036">
            <div className="flex items-center justify-between" data-id="element-4037">
              <div data-id="element-4038">
                <p className="text-sm text-muted-foreground" data-id="element-4039">Active Auctions</p>
                <p className="text-2xl font-bold" data-id="element-4040">
                  {auctionStats.activeAuctions}
                </p>
              </div>
              <GavelIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-4041" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-4042">
          <CardContent className="p-4" data-id="element-4043">
            <div className="flex items-center justify-between" data-id="element-4044">
              <div data-id="element-4045">
                <p className="text-sm text-muted-foreground" data-id="element-4046">
                  Upcoming Auctions
                </p>
                <p className="text-2xl font-bold" data-id="element-4047">
                  {auctionStats.upcomingAuctions}
                </p>
              </div>
              <CalendarIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-4048" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-4049">
          <CardContent className="p-4" data-id="element-4050">
            <div className="flex items-center justify-between" data-id="element-4051">
              <div data-id="element-4052">
                <p className="text-sm text-muted-foreground" data-id="element-4053">Total Bids</p>
                <p className="text-2xl font-bold" data-id="element-4054">{auctionStats.totalBids}</p>
              </div>
              <TagIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-4055" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-4056">
          <CardContent className="p-4" data-id="element-4057">
            <div className="flex items-center justify-between" data-id="element-4058">
              <div data-id="element-4059">
                <p className="text-sm text-muted-foreground" data-id="element-4060">
                  Avg. Price Increase
                </p>
                <p className="text-2xl font-bold" data-id="element-4061">
                  {auctionStats.averagePriceIncrease}
                </p>
              </div>
              <TrendingUpIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-4062" />
            </div>
          </CardContent>
        </Card>
      </div>
      <Card data-id="element-4063">
        <CardHeader className="pb-2" data-id="element-4064">
          <div className="flex items-center justify-between" data-id="element-4065">
            <CardTitle data-id="element-4066">Auction Listings</CardTitle>
            <div className="relative" data-id="element-4067">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-4068" />
              <input type="text" placeholder="Search auctions..." className="pl-10 pr-4 py-2 rounded-md border bg-background text-sm w-64" data-id="element-4069" />
            </div>
          </div>
          <CardDescription data-id="element-4070">
            Browse current and upcoming wholesale auctions
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-4071">
          <Tabs defaultValue="active" value={activeTab} onValueChange={setActiveTab} data-id="element-4072">
            <TabsList className="mb-4" data-id="element-4073">
              <TabsTrigger value="active" data-id="element-4074">Active</TabsTrigger>
              <TabsTrigger value="upcoming" data-id="element-4075">Upcoming</TabsTrigger>
              <TabsTrigger value="ended" data-id="element-4076">Ended</TabsTrigger>
              <TabsTrigger value="my-bids" data-id="element-4077">My Bids</TabsTrigger>
              <TabsTrigger value="syndicate" data-id="element-4078">Syndicate Auctions</TabsTrigger>
            </TabsList>
            <TabsContent value="active" className="space-y-4" data-id="element-4079">
              {auctions.filter(auction => auction.status === 'Active').map(auction => <Card key={auction.id} className="overflow-hidden" data-id="element-4080">
                    <div className="flex flex-col md:flex-row" data-id="element-4081">
                      <div className="p-4 md:w-2/3" data-id="element-4082">
                        <div className="flex items-start justify-between" data-id="element-4083">
                          <div data-id="element-4084">
                            <div className="flex items-center" data-id="element-4085">
                              <h3 className="font-medium" data-id="element-4086">{auction.title}</h3>
                              <Badge variant="success" className="ml-2" data-id="element-4087">
                                Active
                              </Badge>
                              {auction.syndicateBuying && <Badge variant="outline" className="ml-2" data-id="element-4088">
                                  <UsersIcon className="h-3 w-3 mr-1" data-id="element-4089" />
                                  Syndicate Interest
                                </Badge>}
                            </div>
                            <p className="text-sm text-muted-foreground mt-1" data-id="element-4090">
                              ID: {auction.id} • Seller: {auction.seller}
                            </p>
                          </div>
                          <div className="flex items-center text-sm" data-id="element-4091">
                            <ClockIcon className="h-4 w-4 mr-1 text-yellow-500" data-id="element-4092" />
                            <span data-id="element-4093">{auction.timeLeft} left</span>
                          </div>
                        </div>
                        <div className="grid grid-cols-3 gap-4 mt-4" data-id="element-4094">
                          <div data-id="element-4095">
                            <p className="text-xs text-muted-foreground" data-id="element-4096">
                              Devices
                            </p>
                            <p className="font-medium" data-id="element-4097">{auction.devices}</p>
                          </div>
                          <div data-id="element-4098">
                            <p className="text-xs text-muted-foreground" data-id="element-4099">
                              Starting Bid
                            </p>
                            <p className="font-medium" data-id="element-4100">{auction.startingBid}</p>
                          </div>
                          <div data-id="element-4101">
                            <p className="text-xs text-muted-foreground" data-id="element-4102">
                              Current Bid
                            </p>
                            <p className="font-medium text-green-600" data-id="element-4103">
                              {auction.currentBid}
                            </p>
                          </div>
                        </div>
                        {auction.syndicateBuying && auction.syndicateInfo && <div className="mt-4 p-3 bg-primary/5 border rounded-md" data-id="element-4104">
                            <div className="flex justify-between items-center mb-2" data-id="element-4105">
                              <div className="flex items-center" data-id="element-4106">
                                <UsersIcon className="h-4 w-4 mr-2 text-primary" data-id="element-4107" />
                                <span className="font-medium text-sm" data-id="element-4108">
                                  {auction.syndicateInfo.name}
                                </span>
                              </div>
                              <span className="text-xs text-muted-foreground" data-id="element-4109">
                                {auction.syndicateInfo.members} members
                              </span>
                            </div>
                            <div className="space-y-1" data-id="element-4110">
                              <div className="flex justify-between text-xs text-muted-foreground" data-id="element-4111">
                                <span data-id="element-4112">
                                  Capital Raised:{' '}
                                  {auction.syndicateInfo.capitalRaised}
                                </span>
                                <span data-id="element-4113">
                                  Target: {auction.syndicateInfo.targetCapital}
                                </span>
                              </div>
                              <Progress value={auction.syndicateInfo.progress} className="h-1.5" data-id="element-4114" />
                              <div className="flex justify-end" data-id="element-4115">
                                <Button variant="ghost" size="sm" className="h-7 text-xs" onClick={() => navigate('/syndicate-hub')} data-id="element-4116">
                                  Join Syndicate
                                </Button>
                              </div>
                            </div>
                          </div>}
                      </div>
                      <div className="p-4 bg-muted/30 border-t md:border-t-0 md:border-l md:w-1/3 flex flex-col justify-between" data-id="element-4117">
                        <div data-id="element-4118">
                          <div className="flex items-center justify-between mb-2" data-id="element-4119">
                            <span className="text-sm font-medium" data-id="element-4120">
                              Current Bid
                            </span>
                            <span className="font-bold text-lg" data-id="element-4121">
                              {auction.currentBid}
                            </span>
                          </div>
                          <div className="flex items-center justify-between text-sm" data-id="element-4122">
                            <span className="text-muted-foreground" data-id="element-4123">
                              Total Bids
                            </span>
                            <span data-id="element-4124">{auction.bids}</span>
                          </div>
                        </div>
                        <div className="mt-4 space-y-2" data-id="element-4125">
                          <Button className="w-full" data-id="element-4126">Place Bid</Button>
                          <Button variant="outline" className="w-full" data-id="element-4127">
                            View Details
                          </Button>
                          {!auction.syndicateBuying && <Button variant="outline" className="w-full" onClick={() => navigate('/syndicate-hub')} data-id="element-4128">
                              <UsersIcon className="mr-2 h-4 w-4" data-id="element-4129" />
                              Create Buying Syndicate
                            </Button>}
                        </div>
                      </div>
                    </div>
                  </Card>)}
            </TabsContent>
            <TabsContent value="upcoming" data-id="element-4130">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-4131">
                <p className="text-muted-foreground" data-id="element-4132">
                  Upcoming auctions will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="ended" data-id="element-4133">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-4134">
                <p className="text-muted-foreground" data-id="element-4135">
                  Ended auctions will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="my-bids" data-id="element-4136">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-4137">
                <p className="text-muted-foreground" data-id="element-4138">
                  Your bids will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="syndicate" className="space-y-4" data-id="element-4139">
              <Card className="p-6" data-id="element-4140">
                <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-4141">
                  <div className="md:w-2/3 space-y-4" data-id="element-4142">
                    <div className="flex items-center" data-id="element-4143">
                      <div className="h-5 w-5 mr-2 text-primary" data-id="element-4144" />
                      <h3 className="text-lg font-medium" data-id="element-4145">
                        Group Buying Power
                      </h3>
                    </div>
                    <p className="text-muted-foreground" data-id="element-4146">
                      Pool resources with other traders to access larger
                      inventory lots at better prices. Syndicates reduce
                      individual risk while increasing buying power and
                      negotiation leverage.
                    </p>
                    <div className="grid grid-cols-3 gap-4" data-id="element-4147">
                      <div className="p-3 bg-primary/5 rounded-md text-center" data-id="element-4148">
                        <p className="text-2xl font-bold" data-id="element-4149">15-20%</p>
                        <p className="text-xs text-muted-foreground" data-id="element-4150">
                          Better Rates
                        </p>
                      </div>
                      <div className="p-3 bg-primary/5 rounded-md text-center" data-id="element-4151">
                        <p className="text-2xl font-bold" data-id="element-4152">10x</p>
                        <p className="text-xs text-muted-foreground" data-id="element-4153">
                          Buying Power
                        </p>
                      </div>
                      <div className="p-3 bg-primary/5 rounded-md text-center" data-id="element-4154">
                        <p className="text-2xl font-bold" data-id="element-4155">75%</p>
                        <p className="text-xs text-muted-foreground" data-id="element-4156">
                          Risk Reduction
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="md:w-1/3 flex flex-col space-y-3" data-id="element-4157">
                    <Button size="lg" className="w-full" onClick={() => navigate('/syndicate-hub')} data-id="element-4158">
                      <UsersIcon className="mr-2 h-4 w-4" data-id="element-4159" />
                      Create a Syndicate
                    </Button>
                    <Button variant="outline" size="lg" className="w-full" onClick={() => navigate('/syndicate-hub')} data-id="element-4160">
                      <UserPlusIcon className="mr-2 h-4 w-4" data-id="element-4161" />
                      Join Existing Syndicate
                    </Button>
                    <Button variant="ghost" size="lg" className="w-full" onClick={() => navigate('/syndicate-hub')} data-id="element-4162">
                      Learn More
                    </Button>
                  </div>
                </div>
              </Card>
              {auctions.filter(auction => auction.syndicateBuying).map(auction => <Card key={auction.id} className="overflow-hidden" data-id="element-4163">
                    <div className="flex flex-col md:flex-row" data-id="element-4164">
                      <div className="p-4 md:w-2/3" data-id="element-4165">
                        <div className="flex items-start justify-between" data-id="element-4166">
                          <div data-id="element-4167">
                            <div className="flex items-center" data-id="element-4168">
                              <h3 className="font-medium" data-id="element-4169">{auction.title}</h3>
                              <Badge variant="success" className="ml-2" data-id="element-4170">
                                Active
                              </Badge>
                              <Badge variant="outline" className="ml-2" data-id="element-4171">
                                <UsersIcon className="h-3 w-3 mr-1" data-id="element-4172" />
                                Syndicate
                              </Badge>
                            </div>
                            <p className="text-sm text-muted-foreground mt-1" data-id="element-4173">
                              ID: {auction.id} • Seller: {auction.seller}
                            </p>
                          </div>
                          <div className="flex items-center text-sm" data-id="element-4174">
                            <ClockIcon className="h-4 w-4 mr-1 text-yellow-500" data-id="element-4175" />
                            <span data-id="element-4176">{auction.timeLeft} left</span>
                          </div>
                        </div>
                        <div className="grid grid-cols-3 gap-4 mt-4" data-id="element-4177">
                          <div data-id="element-4178">
                            <p className="text-xs text-muted-foreground" data-id="element-4179">
                              Devices
                            </p>
                            <p className="font-medium" data-id="element-4180">{auction.devices}</p>
                          </div>
                          <div data-id="element-4181">
                            <p className="text-xs text-muted-foreground" data-id="element-4182">
                              Starting Bid
                            </p>
                            <p className="font-medium" data-id="element-4183">{auction.startingBid}</p>
                          </div>
                          <div data-id="element-4184">
                            <p className="text-xs text-muted-foreground" data-id="element-4185">
                              Current Bid
                            </p>
                            <p className="font-medium text-green-600" data-id="element-4186">
                              {auction.currentBid}
                            </p>
                          </div>
                        </div>
                        {auction.syndicateInfo && <div className="mt-4 p-3 bg-primary/5 border rounded-md" data-id="element-4187">
                            <div className="flex justify-between items-center mb-2" data-id="element-4188">
                              <div className="flex items-center" data-id="element-4189">
                                <UsersIcon className="h-4 w-4 mr-2 text-primary" data-id="element-4190" />
                                <span className="font-medium text-sm" data-id="element-4191">
                                  {auction.syndicateInfo.name}
                                </span>
                              </div>
                              <span className="text-xs text-muted-foreground" data-id="element-4192">
                                {auction.syndicateInfo.members} members
                              </span>
                            </div>
                            <div className="space-y-1" data-id="element-4193">
                              <div className="flex justify-between text-xs text-muted-foreground" data-id="element-4194">
                                <span data-id="element-4195">
                                  Capital Raised:{' '}
                                  {auction.syndicateInfo.capitalRaised}
                                </span>
                                <span data-id="element-4196">
                                  Target: {auction.syndicateInfo.targetCapital}
                                </span>
                              </div>
                              <Progress value={auction.syndicateInfo.progress} className="h-1.5" data-id="element-4197" />
                            </div>
                          </div>}
                      </div>
                      <div className="p-4 bg-muted/30 border-t md:border-t-0 md:border-l md:w-1/3 flex flex-col justify-between" data-id="element-4198">
                        <div data-id="element-4199">
                          <div className="flex items-center justify-between mb-2" data-id="element-4200">
                            <span className="text-sm font-medium" data-id="element-4201">
                              Min. Contribution
                            </span>
                            <span className="font-bold text-lg" data-id="element-4202">$5,000</span>
                          </div>
                          <div className="flex items-center text-sm text-muted-foreground mb-1" data-id="element-4203">
                            <ShieldIcon className="h-4 w-4 mr-1" data-id="element-4204" />
                            <span data-id="element-4205">Escrow protected funds</span>
                          </div>
                          <div className="flex items-center text-sm text-muted-foreground" data-id="element-4206">
                            <UsersIcon className="h-4 w-4 mr-1" data-id="element-4207" />
                            <span data-id="element-4208">
                              Join with {auction.syndicateInfo?.members} other
                              traders
                            </span>
                          </div>
                        </div>
                        <div className="mt-4 space-y-2" data-id="element-4209">
                          <Button className="w-full" onClick={() => navigate('/syndicate-hub')} data-id="element-4210">
                            Join Syndicate
                          </Button>
                          <Button variant="outline" className="w-full" onClick={() => navigate('/syndicate-hub')} data-id="element-4211">
                            View Syndicate Details
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Card>)}
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4212">
        <Card className="md:col-span-2" data-id="element-4213">
          <CardHeader data-id="element-4214">
            <CardTitle data-id="element-4215">Recent Bids</CardTitle>
            <CardDescription data-id="element-4216">
              Latest activity across all auctions
            </CardDescription>
          </CardHeader>
          <CardContent data-id="element-4217">
            <div className="space-y-4" data-id="element-4218">
              {recentBids.map(bid => <div key={bid.id} className="flex items-start p-3 border rounded-md" data-id="element-4219">
                  <TagIcon className="h-5 w-5 text-blue-500 mr-3 mt-0.5" data-id="element-4220" />
                  <div className="flex-1" data-id="element-4221">
                    <div className="flex items-center justify-between" data-id="element-4222">
                      <p className="font-medium" data-id="element-4223">{bid.bidder}</p>
                      <p className="font-bold text-green-600" data-id="element-4224">{bid.amount}</p>
                    </div>
                    <div className="flex items-center justify-between mt-1" data-id="element-4225">
                      <p className="text-sm text-muted-foreground" data-id="element-4226">
                        {bid.auction}
                      </p>
                      <p className="text-xs text-muted-foreground" data-id="element-4227">
                        {bid.time}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </CardContent>
          <CardFooter className="border-t" data-id="element-4228">
            <Button variant="outline" size="sm" className="ml-auto" data-id="element-4229">
              View All Bids
            </Button>
          </CardFooter>
        </Card>
        <Card data-id="element-4230">
          <CardHeader data-id="element-4231">
            <CardTitle data-id="element-4232">Group Buying Power</CardTitle>
            <CardDescription data-id="element-4233">Pool resources with other traders</CardDescription>
          </CardHeader>
          <CardContent data-id="element-4234">
            <div className="space-y-4" data-id="element-4235">
              <div className="p-4 border rounded-md bg-primary/5" data-id="element-4236">
                <div className="flex items-start" data-id="element-4237">
                  <UsersIcon className="h-5 w-5 text-primary mr-2 mt-0.5" data-id="element-4238" />
                  <div data-id="element-4239">
                    <p className="text-sm font-medium" data-id="element-4240">
                      Syndicate Buying Model
                    </p>
                    <p className="text-xs text-muted-foreground mt-1" data-id="element-4241">
                      Pool capital with other traders to access larger inventory
                      opportunities and reduce individual risk
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-2" data-id="element-4242">
                <Button className="w-full" onClick={() => navigate('/syndicate-hub')} data-id="element-4243">
                  <UsersIcon className="mr-2 h-4 w-4" data-id="element-4244" />
                  Visit Syndicate Hub
                </Button>
                <Button variant="outline" className="w-full" onClick={() => navigate('/syndicate-hub')} data-id="element-4245">
                  <div className="mr-2 h-4 w-4" data-id="element-4246" />
                  Join Active Syndicates
                </Button>
              </div>
              <div className="mt-4" data-id="element-4247">
                <h4 className="text-sm font-medium mb-2" data-id="element-4248">Benefits</h4>
                <div className="space-y-2 text-sm" data-id="element-4249">
                  <div className="flex items-start" data-id="element-4250">
                    <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-4251" />
                    <span className="text-muted-foreground" data-id="element-4252">
                      Access larger inventory lots
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-4253">
                    <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-4254" />
                    <span className="text-muted-foreground" data-id="element-4255">
                      Reduce individual risk exposure
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-4256">
                    <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-4257" />
                    <span className="text-muted-foreground" data-id="element-4258">
                      Negotiate better wholesale rates
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-4259">
                    <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-4260" />
                    <span className="text-muted-foreground" data-id="element-4261">
                      Secure escrow protection for funds
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <Card data-id="element-4262">
        <CardHeader data-id="element-4263">
          <CardTitle data-id="element-4264">Featured Auction</CardTitle>
          <CardDescription data-id="element-4265">
            Special highlight with premium visibility
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-4266">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4267">
            <div className="space-y-4" data-id="element-4268">
              <div className="flex items-center" data-id="element-4269">
                <h3 className="text-xl font-bold" data-id="element-4270">Premium iPhone Collection</h3>
                <Badge variant="success" className="ml-2" data-id="element-4271">
                  Featured
                </Badge>
                <Badge variant="outline" className="ml-2" data-id="element-4272">
                  <UsersIcon className="h-3 w-3 mr-1" data-id="element-4273" />
                  Syndicate Ready
                </Badge>
              </div>
              <p className="text-muted-foreground" data-id="element-4274">
                A curated collection of 40 premium iPhones including iPhone 13
                Pro, iPhone 13, and iPhone 12 Pro models. All devices are A/B
                grade with full functionality and minimal cosmetic wear.
              </p>
              <div className="grid grid-cols-2 gap-4" data-id="element-4275">
                <div data-id="element-4276">
                  <p className="text-sm text-muted-foreground" data-id="element-4277">Starting Bid</p>
                  <p className="text-2xl font-bold" data-id="element-4278">$15,000</p>
                </div>
                <div data-id="element-4279">
                  <p className="text-sm text-muted-foreground" data-id="element-4280">Reserve Price</p>
                  <p className="text-2xl font-bold" data-id="element-4281">$18,500</p>
                </div>
              </div>
              <div className="flex items-center space-x-4" data-id="element-4282">
                <div className="flex items-center" data-id="element-4283">
                  <UsersIcon className="h-4 w-4 mr-1 text-muted-foreground" data-id="element-4284" />
                  <span className="text-sm" data-id="element-4285">12 watchers</span>
                </div>
                <div className="flex items-center" data-id="element-4286">
                  <TimerIcon className="h-4 w-4 mr-1 text-yellow-500" data-id="element-4287" />
                  <span className="text-sm" data-id="element-4288">Ends in 2 days</span>
                </div>
              </div>
              <div className="flex space-x-2" data-id="element-4289">
                <Button className="flex-1" data-id="element-4290">Place Bid</Button>
                <Button variant="outline" className="flex-1" data-id="element-4291">
                  View Details
                </Button>
                <Button variant="outline" className="flex-1" onClick={() => navigate('/syndicate-hub')} data-id="element-4292">
                  <UsersIcon className="mr-2 h-4 w-4" data-id="element-4293" />
                  Join Syndicate
                </Button>
              </div>
            </div>
            <div className="flex items-center justify-center p-6 bg-muted/30 rounded-md border" data-id="element-4294">
              <div className="text-center" data-id="element-4295">
                <BoxIcon className="h-16 w-16 mx-auto text-muted-foreground/50 mb-4" data-id="element-4296" />
                <p className="text-muted-foreground" data-id="element-4297">
                  Preview image would appear here
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
};
export default WholesaleAuctions;